import script from "./CurtainAnimation.vue?vue&type=script&setup=true&lang=ts"
export * from "./CurtainAnimation.vue?vue&type=script&setup=true&lang=ts"

import "./CurtainAnimation.vue?vue&type=style&index=0&id=de1062f6&lang=css"

const __exports__ = script;

export default __exports__